import {applySetLang} from '@wf-components/common-components-consumer';

/** Safe inside either `href="..."` or `href='...'`. */
function escapeHtmlHrefAttr(value: string): string {
	return value
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

/**
 * Finds opening `<a ...>` tags in an HTML string, reads `href="..."` or `href='...'`,
 * and rewrites http(s) URLs with wf-components {@link applySetLang}.
 * Tags without a single- or double-quoted `href` are left unchanged.
 *
 * @param html - Trusted CMS HTML (e.g. FAQ body).
 */
export function applySetLangToHtmlAnchors(html: string): string {
	if (!html || !window._epicSetLangLocale) {
		return html;
	}

	return html.replace(/<a\b[^>]*>/gi, (openTag) => {
		const m = /\bhref\s*=\s*(?:"([^"]*)"|'([^']*)')/i.exec(openTag);
		if (!m || m.index === undefined) {
			return openTag;
		}

		const raw = m[1] ?? m[2];
		if (raw === undefined || !raw.trim()) {
			return openTag;
		}

		let newHref = raw;
		try {
			const url = new URL(raw.trim());
			if (url.protocol === 'http:' || url.protocol === 'https:') {
				newHref = applySetLang(url.href, window._epicSetLangLocale ?? '');
			} else {
				return openTag;
			}
		} catch {
			return openTag;
		}

		const quote = m[2] !== undefined ? "'" : '"';
		const escaped = escapeHtmlHrefAttr(newHref);
		const start = m.index;
		const end = start + m[0].length;
		return `${openTag.slice(0, start)}href=${quote}${escaped}${quote}${openTag.slice(end)}`;
	});
}
